import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { Menu } from 'primeng/menu';
import type { MenuItem } from 'primeng/api';

import { AuthService } from '../../../core/auth/auth.service';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-sidebar-user',
  imports: [Menu, LoadingSpinnerComponent],
  host: {
    '[class.app-sidebar-user-host--avatar-only]': 'avatarOnly()',
  },
  templateUrl: './app-sidebar-user.component.html',
  styleUrl: './app-sidebar-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSidebarUserComponent {
  /** Collapsed L1: avatar control only (account menu unchanged). */
  readonly avatarOnly = input(false);

  protected readonly authService = inject(AuthService);
  protected readonly authDisabledLabel = 'AUTH DISABLED';
  protected readonly authDisabledInitials = 'AD';

  private readonly accountMenu = viewChild<Menu>('accountMenu');

  protected readonly menuItems = computed<MenuItem[]>(() => {
    const items: MenuItem[] = [];
    const email = this.authService.email();

    if (email) {
      items.push({
        label: 'Signed in as',
        disabled: true,
        styleClass: 'app-sidebar-user-menu__heading',
      });
      items.push({
        label: email,
        disabled: true,
        title: email,
        styleClass: 'app-sidebar-user-menu__email',
        labelClass: 'app-sidebar-user-menu__email-label',
      });
      items.push({ separator: true });
    }

    items.push({
      label: 'Sign out',
      icon: 'pi pi-sign-out',
      disabled: this.authService.isLoggingOut(),
      command: () => {
        void this.signOut();
      },
    });

    return items;
  });

  protected toggleAccountMenu(event: Event): void {
    if (this.authService.isLoggingOut()) {
      return;
    }

    this.accountMenu()?.toggle(event);
  }

  protected async signOut(): Promise<void> {
    this.accountMenu()?.hide();
    await this.authService.logout();
  }
}
